import { CustomerByContractRequest } from '@/api/models/BaseRequest';
import { ContractDetails } from '@/utils/types/contractDetails';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

// Define the contract details state type
export interface ContractDetailsState {
  contractDetails: ContractDetails | null;
  loading: boolean;
  error: string | null;
}

// Initial state
const initialState: ContractDetailsState = {
  contractDetails: null,
  loading: false,
  error: null,
};

// Create contract details slice
const contractDetailsSlice = createSlice({
  name: 'contractDetails',
  initialState,
  reducers: {
    fetchContractDetailsStart(state, _action: PayloadAction<CustomerByContractRequest>) {
      state.loading = true;
      state.error = null;
    },
    fetchContractDetailsSuccess(state, action: PayloadAction<ContractDetails>) {
      state.contractDetails = action.payload;
      state.loading = false;
      state.error = null;
    },
    fetchContractDetailsFailure(state, action: PayloadAction<string>) {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

// Export actions
export const {
  fetchContractDetailsStart,
  fetchContractDetailsSuccess,
  fetchContractDetailsFailure,
} = contractDetailsSlice.actions;

// Export reducer
export default contractDetailsSlice.reducer;
